import React from 'react';
import { Card } from './ui/Card';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María González',
    location: 'Miami, FL',
    rating: 5,
    text: 'Excelente servicio. Mis padres en Cuba recibieron el combo de comida en tiempo récord. La calidad de los productos es increíble. ¡Totalmente recomendado!',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
  }, {
    name: 'Carlos Ramírez',
    location: 'Madrid, España',
    rating: 5,
    text: 'Llevo años usando Mega Revolution y nunca me han fallado. El seguimiento en tiempo real me da mucha tranquilidad. Mis familiares siempre reciben todo perfecto.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
  }, {
    name: 'Ana Martínez',
    location: 'Nueva York, NY',
    rating: 5,
    text: 'Los combos de comida son una bendición. Ahora puedo asegurarme de que mi abuela tenga todo lo que necesita. El proceso es súper fácil y el precio es justo.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
  }];
  return <section className="w-full bg-gray-50 py-16 md:py-24" data-id="element-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
        <div className="text-center mb-12" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-203">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-204">
            Miles de familias confían en nosotros cada día
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-205">
          {testimonials.map((testimonial, index) => <Card key={index} className="p-8" data-id="element-206">
              <div className="mb-6" data-id="element-207">
                <QuoteIcon className="h-10 w-10 text-red-600 opacity-20" data-id="element-208" />
              </div>

              <div className="flex gap-1 mb-4" data-id="element-209">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" data-id="element-210" />)}
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-211">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4 pt-4 border-t" data-id="element-212">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-213" />
                <div data-id="element-214">
                  <div className="font-semibold text-gray-900" data-id="element-215">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-216">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}